export const POST_FORM = 'POST_FORM';

export const DELETE_LAST_POST_FORM = 'DELETE_LAST_POST_FORM';

export const CLEAN_FORM = 'CLEAN_FORM';
